import React from 'react';
import EsignLandingPageFullWidthUploadPanel from './EsignLandingPageFullWidthUploadPanel';
import EsignLandingPageBenefitsSection from './EsignLandingPageBenefitsSection';

const EsignLandingPageFullWidthUploadPanelLayout = () => (
  <div className="sem-esign-wrapper">
    <div className="indexRedesign large-upload-panel-wrapper">
      <div className="container-fluid">
        <div className="row-fluid">
          <div className="span12 editor-landing">
            <div className="large-upload-panel-info-wrapper">
              <h1 className="large-upload-panel-page-header">eSign Any Document</h1>
              <h2 className="large-upload-panel-page-sub-header">
                Sign and send signature requests to anyone, from anywhere - instantly.
              </h2>
            </div>
          </div>
          <EsignLandingPageFullWidthUploadPanel subHeader="PDF, Word Document, Image" />
        </div>
        <EsignLandingPageBenefitsSection isFullWidthUploadPanel />
      </div>
    </div>
  </div>
);

export default EsignLandingPageFullWidthUploadPanelLayout;



// WEBPACK FOOTER //
// ./src-react/EsignLandingPage/EsignLandingPageFullWidthUploadPanelLayout.jsx